import { dispatchAction } from '../dispatcher/AppDispatcher';
import FormattersActionTypes from '../constants/actionTypes/Formatters';

export function setFormatters(data) {
  dispatchAction({
    type: FormattersActionTypes.SET_FORMATTERS,
    data
  });
}
